export const FETCH_VERSION_DATA_SUCCESS = 'FETCH_VERSION_DATA_SUCCESS';

export const FETCH_VERSION_DATA_FAILURE = 'FETCH_VERSION_DATA_FAILURE';